import { Avatar, Col, Dropdown, Menu } from 'antd';
import classnames from 'classnames';
import {
  NotificationContentContainerStyled,
  NotificationIconContainerStyled,
  NotificationOuterContainerStyled,
} from 'components/AppNotification/styled';
import { FORMAT_DATE_TIME_US_FOR_DISPLAY } from 'constants/days';
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import NotificationAction from 'redux/notification/notification.action';
import { INotification, NotificationStatus, NotificationType } from 'redux/notification/types';
import { IComponentTheme } from 'types/common';

interface INotificationItemProps {
  notification: INotification;
}

const NotificationItem: React.FC<INotificationItemProps & IComponentTheme> = ({ notification, dark = false }) => {
  const { icon, link = '', image, title, description, createdAt, onClick, status, name, type } = notification;

  const dispatch = useDispatch();

  const Wrapper = React.useCallback(
    ({ children }: { children: any }) => {
      switch (type) {
        default:
        case NotificationType.REQUIRE_ACTION: {
          return (
            <Link to={link || ''} style={{ color: 'inherit' }}>
              {children}
            </Link>
          );
        }
      }
    },
    [type],
  );

  const onClickRead = () => {
    dispatch(NotificationAction.readNotification(notification));
  };

  const onClickDelete = () => {
    dispatch(NotificationAction.deleteNotification(notification));
  };

  const readAndExecuteOnClick = () => {
    onClickRead();
    onClick?.();
  };

  const itemMenu = (
    <Menu>
      <Menu.Item key='1' onClick={onClickRead}>
        Read
      </Menu.Item>
      <Menu.Item key='2' onClick={onClickDelete}>
        Delete
      </Menu.Item>
    </Menu>
  );

  return (
    <li className='notification-item-wrapper'>
      <Wrapper>
        <NotificationOuterContainerStyled
          onClick={readAndExecuteOnClick}
          className={classnames('gx-media-body gx-align-self-center', {
            dark,
            unread: status === NotificationStatus.UNREAD,
          })}>
          <Col flex='40px'>
            <Avatar className='gx-size-40 gx-mr-2' alt={image} src={image}>
              {!image && (name || 'System')}
            </Avatar>
          </Col>
          <Col flex={1}>
            <NotificationContentContainerStyled>
              <NotificationIconContainerStyled>
                <i className={`icon icon-${icon} gx-pr-2`} />
              </NotificationIconContainerStyled>
              <Col>
                <p className='gx-fs-md gx-mb-0'>{title}</p>
                <p className='gx-fs-md gx-mb-0'>{description}</p>
                <span className='gx-meta-date'>
                  <small>{moment(createdAt).format(FORMAT_DATE_TIME_US_FOR_DISPLAY)}</small>
                </span>
              </Col>
            </NotificationContentContainerStyled>
          </Col>
        </NotificationOuterContainerStyled>
      </Wrapper>
      <Dropdown overlay={itemMenu} trigger={['click']}>
        <div className='menu-wrapper'>
          <i className='gx-icon-btn icon icon-charvlet-down' />
        </div>
      </Dropdown>
    </li>
  );
};

export default NotificationItem;
